import { TableView } from 'owa-mail-list-store';
import * as React from 'react';
import { observer } from 'mobx-react';
import HeaderButtonData from '../../models/HeaderButtonData';
import { ActionButton } from '@fluentui/react/lib/Button';
import {
    useLivePersonaCard,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';
import MailPersonaSearchResultsHeader from 'owa-mail-list-view/lib/components/listHeaders/MailPersonaSearchResultsHeader';
import { isFeatureEnabled } from 'owa-feature-flags';

const styles = require('./HeaderActions.scss');

interface Props {
    tableView: TableView;
    hideCheckAll: boolean;
    hideFilter: boolean;
    actionButtonData: HeaderButtonData[];
    headerActionsStylesAsPerUserSettings?: string;
}

function headerActions(props: Props): JSX.Element {
    const isListViewEmpty = props.tableView && !props.tableView.rowKeys.length;
    const displaySecondRow =
        !isFeatureEnabled('sea-interactiveFilters') &&
        ((!props.hideCheckAll && !isListViewEmpty) || !props.hideFilter);

    return (
        <>
            <div className={styles.buttonsWrapperV2}>
                {props.actionButtonData.map((data, idx) =>
                    getButtonForData(data, idx === props.actionButtonData.length - 1)
                )}
            </div>
            {displaySecondRow && (
                <MailPersonaSearchResultsHeader
                    tableView={props.tableView}
                    hideCheckAll={props.hideCheckAll}
                    hideFilter={props.hideFilter}
                    styleSelectorAsPerUserSettings={props.headerActionsStylesAsPerUserSettings}
                />
            )}
        </>
    );
}

function getButtonForData(actionButtonData: HeaderButtonData, isLastButton: boolean): JSX.Element {
    if (!actionButtonData) {
        return null;
    }

    const buttonStyles = {
        root: isLastButton ? styles.lastButton : styles.button,
        label: isLastButton ? styles.lastLabelContainer : '',
        textContainer: isLastButton ? styles.lastTextContainer : '',
    };

    if (actionButtonData.isLPCWrapped) {
        return (
            <LPCWrapper
                key={actionButtonData.personaEmail}
                emailAddress={actionButtonData.personaEmail}
                name={actionButtonData.personaName}
                locationToOpen={actionButtonData.lpcLocationToOpen}
                clientScenario={actionButtonData.lpcClientScenario}
                className={isLastButton ? styles.lastLpcWrapperClass : ''}>
                <ActionButton
                    iconProps={{
                        iconName: actionButtonData.icon,
                    }}
                    styles={buttonStyles}
                    text={actionButtonData.text}
                />
            </LPCWrapper>
        );
    } else {
        const button = (
            <ActionButton
                key={actionButtonData.text}
                iconProps={{
                    iconName: actionButtonData.icon,
                }}
                styles={buttonStyles}
                text={actionButtonData.text}
                onClick={actionButtonData.clickCallback}
            />
        );

        return isLastButton ? <span className={styles.lastLpcWrapperClass}>{button}</span> : button;
    }
}

function LPCWrapper(props: PersonaCardBehaviorProps & { children: React.ReactNode }) {
    const PersonaCardBehavior = useLivePersonaCard(props);
    return <PersonaCardBehavior>{props.children}</PersonaCardBehavior>;
}

export default observer(headerActions);
